







































































































































































































































































































































































































































































































































import {Component, Watch, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CTable from '@/components/base/table/CTable.vue';
@Component({
    components: {CTable, CNumberField, CCheckbox, CSelect, CEditDialog},
})
export default class PlanShiftCountEditDialog extends Mixins(EditDialogMixin) {
    private IdShiftTmlToCopy: number | null = null;
    private gettingShiftTmlCopyData: boolean = false;

    get sizesHeaders() {
        return [
            {
                value: 'IdPlywoodSize',
                text: this.$t('Catalogues.Plywoods.PlywoodSize.NameSingle'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.plywoodSize),
                ),
            },
            {
                value: 'MinMaxVolumeParameters.MinVolume',
                text: `${this.$t('Common.MinVolume')} (${this.$t('Common.M3')})`,
            },
            {
                value: 'MinMaxVolumeParameters.MaxVolume',
                text: `${this.$t('Common.MaxVolume')} (${this.$t('Common.M3')})`,
            },
        ];
    }

    get gradesHeaders() {
        return [
            {
                value: 'IdPlywoodGrade',
                text: this.$t('Catalogues.Plywoods.PlywoodGrade.NameSingle'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.plywoodGrade),
                ),
            },
            {
                value: 'MinMaxVolumeParameters.MinVolume',
                text: `${this.$t('Common.MinVolume')} (${this.$t('Common.M3')})`,
            },
            {
                value: 'MinMaxVolumeParameters.MaxVolume',
                text: `${this.$t('Common.MaxVolume')} (${this.$t('Common.M3')})`,
            },
        ];
    }

    get thicknessesHeaders() {
        return [
            {
                value: 'IdPlywoodThickness',
                text: this.$t('Catalogues.Plywoods.PlywoodThickness.NameSingle'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.plywoodThickness),
                ),
            },
            {
                value: 'MinMaxVolumeParameters.MinVolume',
                text: `${this.$t('Common.MinVolume')} (${this.$t('Common.M3')})`,
            },
            {
                value: 'MinMaxVolumeParameters.MaxVolume',
                text: `${this.$t('Common.MaxVolume')} (${this.$t('Common.M3')})`,
            },
        ];
    }

    @Watch('IdShiftTmlToCopy')
    async onIdShiftTmlToCopyChange(value: number) {
        if (value === null) return;
        const timerId = setTimeout(() => (this.gettingShiftTmlCopyData = true), 150);
        try {
            const {data} = await this.$http.get(`${this.$api.catalogues.shiftTml}/GetEdit`, {
                params: {
                    Id: value,
                },
            });
            const Id = this.data.Item.Id,
                Name = this.data.Item.Name;
            this.data.Item = Object.assign(this.data.Item, data, {Id, Name});
        } finally {
            clearTimeout(timerId);
            this.gettingShiftTmlCopyData = false;
        }
    }

    clear() {
        this.data = null;
        this.IdShiftTmlToCopy = null;
    }
}
